<app-hero [data]="heroData"></app-hero>

<div class="row m-5 p-xl-5 corsi-container text-center">
  <!--parte card corsi-->
  <div class="corsi">
    <div>
      <h2 class="blue-50 bold">I corsi per la scuola primaria e secondaria</h2>
      <div class="neutral-90 mt-4 mt-xl-3 mb-xl-5 course-desc">
        Dai un’occhiata alla nostra selezione di corsi per l’educazione al
        digitale nelle scuole!<br />
        Abbiamo un catalogo ricco e variegato, che spazia dai corsi di coding e
        robotica educativa ai corsi di programmazione vera e propria. <br />
        Scopri le nostre proposte per tutte le classi della scuola primaria e
        della scuola secondaria.
      </div>
    </div>
    <div class="row p-0 m-0">
      <!-- desktop view -->
      <div
        class="row col-12 p-0 m-0 courses-list d-none d-lg-block"
        style="gap: 30px; display: inline-flex; background-color: #ffffff"
      >
        <div class="row g-3">
          <div
            class="mb-4 col-4"
            *ngFor="let course of coursesList"
            style="margin: auto"
          >
            <div class="course-card">
              <img
                [src]="course.img"
                class="course-img"
                alt="Un mondo di corsi per mettersi in gioco"
               
              />

              <div class="course-txt p-3">
                <h3 class="blue-60 w-700 course-ttl">{{ course.name }}</h3>
                <span class="course-desc card-description">{{ course.text }}</span>
                <button
                  class="course-link mt-5"
                  (click)="openCourse(course)"
                  [attr.aria-label]="'Scopri il corso ' + course.name"
                ><span class="visually-hidden">Scopri il corso {{ course.name }}</span></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- mobile view -->
      <div
        class="row col-12 p-0 m-0 courses-list d-block d-md-block d-lg-none"
        style="gap: 30px; display: inline-flex; background-color: #ffffff"
        #myElement
      >
        <ng-container *ngFor="let course of coursesList">
          <div
            class="mb-4 pointer"
            *ngIf="course.id === slideSelected"
            style="margin: auto"
          >
            <div class="course-card">
              <img
                [src]="course.img"
                class="course-img"
                alt="Un mondo di corsi per mettersi in gioco"
               
              />

              <div class="course-txt p-3">
                <h3 class="blue-60 w-700 course-ttl">{{ course.name }}</h3>
                <span class="course-desc">{{ course.text }}</span>
                <button
                  class="course-link mt-5"
                  (click)="openCourse(course)"
                  [attr.aria-label]="'Scopri il corso ' + course.name"
                ><span class="visually-hidden">Scopri il corso {{ course.name }}</span></button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="col-1"></div>
      <div class="row d-block d-md-block d-lg-none">
        <div class="col pointer-slide">
          <div (click)="changeSlide(1)" class="pointer">
            <img src="assets/img/slide-selected.svg" *ngIf="slideSelected == 1" alt="" aria-hidden="true" />
            <img src="assets/img/slide-unselected.svg" *ngIf="slideSelected != 1" alt="" aria-hidden="true" />
          </div>
          <div (click)="changeSlide(2)" class="pointer">
            <img src="assets/img/slide-selected.svg" *ngIf="slideSelected == 2" alt="" aria-hidden="true" />
            <img src="assets/img/slide-unselected.svg" *ngIf="slideSelected != 2" alt="" aria-hidden="true" />
          </div>
          <div (click)="changeSlide(3)" class="pointer">
            <img src="assets/img/slide-selected.svg" *ngIf="slideSelected == 3" alt="" aria-hidden="true" />
            <img src="assets/img/slide-unselected.svg" *ngIf="slideSelected != 3" alt="" aria-hidden="true" />
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex; justify-content: center">
      <button class="btn-lightblue my-5" routerLink="/corsi-coding">
        <span class="button-txt">Vai ai corsi</span>
      </button>
    </div>
  </div>
</div>

<div class="counter-container grid mt-5">
  <div class="row">
    <div class="col-xl-4 mb-5 mb-xl-0 pb-5 pb-xl-0">
      <div class="counter-card studenti-img"></div>
    </div>
    <div class="col-xl-4 mb-5 mb-xl-0 pb-5 pb-xl-0">
      <div class="counter-card corsi-img"></div>
    </div>
    <div class="col-xl-4 mb-xl-0 pb-5 pb-xl-0">
      <div class="counter-card lezioni-img"></div>
    </div>
  </div>
</div>

<!--parte info-->

<!-- <div class="row corsi-container text-center" style="background: none">
  <div class="corsi">
    <div>
      <h2 class="blue-50 bold">Sei un docente o un genitore?</h2>
      <div class="neutral-90 mt-4 mt-xl-3 mb-xl-5 course-desc">
        Se sei un docente della scuola primaria e stai cercando delle risorse
        per introdurre i tuoi studenti <br />
        all’educazione digitale e all’innovazione, sei nel posto giusto!
        <br />Dai un’occhiata alle nostre schede da stampare e colorare, oppure
        ai nostri contenuti di sostegno gratuiti.
      </div>
    </div>

    <div class="row p-0 m-0">
    -->

<!-- desktop view -->
<!--       <section class="d-none d-lg-block">
      <div
        class="row col-12 p-0 m-0 courses-list "
        style="gap: 30px; display: inline-flex; background-color: #ffffff"
      >
        <div class="row g-3">
          <div
            class="mb-4 col-4"
            *ngFor="let course of infoList"
            style="margin: auto"
          >
            <div class="course-card">
              <img
                [src]="course.img"
                class="course-img"
                alt="Un mondo di corsi per mettersi in gioco"
               
              />

              <div class="course-txt p-3">
                <h3 class="blue-60 w-700 course-ttl">{{ course.name }}</h3>
                <span class="course-desc">{{ course.text }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
<!--     </div>
  </div>
</div>
 -->
<!-- mobile view -->
<!-- <section class="d-block d-md-block d-lg-none">
<div class="info-sm ">
  <div class="info-1">
    <div>Schede didattiche</div>
    <img src="../../../assets/img/button-arrow.svg" />
  </div>
  <div class="info-2">
    <div>Blog</div>
    <img src="../../../assets/img/button-arrow.svg" />
  </div>
  <div class="info-1">
    <div>Per scoprire di più</div>
    <img src="../../../assets/img/button-arrow.svg" />
  </div>
</div>
</section> -->
<div class="row p-xl-5 corsi-container text-center" style="background: none">
  <!--parte scuola-->
  <!--desktop view-->
  <div
    class="row p-xl-5 corsi-container text-center d-none d-lg-block"
    style="background: none"
  >
    <div class="corsi">
      <div>
        <h2 class="blue-50 bold">Sei una scuola?</h2>
        <div class="neutral-90 mt-4 mt-xl-3 mb-xl-5 course-desc">
          Iscriviti per entrare in contatto con noi e ricevere una proposta
          personalizzata di corsi di coding, robotica educativa e programmazione
          per le tue classi di scuola primaria o secondaria. Con la nostra
          piattaforma potrai inoltre tenere traccia dei progressi di ogni tuo
          studente e utilizzare la piattaforma di corsi in autonomia.

          <div style="display: flex; justify-content: center">
            <button class="btn-lightblue my-5" routerLink="/piattaforma-di-apprendimento">
              <span class="button-txt">Vai alla piattaforma</span>
            </button>
          </div>

          <img src="../../../assets/img/Elementari.svg" alt="" aria-hidden="true" />
        </div>
      </div>
      <div class="background-container">
        <div class="corsi-easy-container">
          <div class="corsi-easy-container-desc">
            Grazie ai corsi di Easycode, scoprirai insieme alla tua classe come
            la tecnologia possa essere utilizzata per migliorare la tua vita e
            quella degli altri. L’educazione digitale è fondamentale, per
            restare al passo con i tempi e prepararsi ad affrontare le sfide del
            domani.
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--mobile view-->
  <section class="d-block d-md-block d-lg-none">
    <div class="row p-xl-5" style="background: none">
      <div class="corsi">
        <div>
          <h2 class="blue-50 bold">Sei una scuola?</h2>
          <div class="neutral-90 mt-4 mt-xl-3 mb-xl-5 course-desc">
            Iscriviti per entrare in contatto con noi e ricevere una proposta
            personalizzata di corsi di coding, robotica educativa e
            programmazione per le tue classi di scuola primaria o secondaria.
            Con la nostra piattaforma potrai inoltre tenere traccia dei progressi di
            ogni tuo studente e utilizzare la piattaforma di corsi in autonomia.
          </div>
        </div>
        <img src="../../../assets/img/Elementari.svg" alt="" aria-hidden="true" />
      </div>
    </div>
  </section>
</div>

<!--desktop view-->
<section class="d-none d-lg-block">
  <div class="obiettivo">
    <div class="ob-col1">
      <div class="obiettivo-title">
        <h2 class="blue-50 bold">Obiettivo inclusività</h2>
      </div>
      <div class="neutral-90 mt-4 mt-xl-3 mb-xl-5 course-desc">
        I nostri corsi di coding ed educazione al digitale promuovono non
        soltanto lo sviluppo di competenze tecniche, informatiche e il problem
        solving, ma anche di importanti valori come l’inclusività. Tramite il
        coding, bambini e ragazzi possono apprendere i valori della cooperazione
        e della collaborazione (cooperative learning): scoprono che un problema
        può essere risolto più facilmente se condividono idee e suggerimenti. La
        classe diventa una comunità di apprendimento, in cui le conoscenze sono
        costruite, condivise e scambiate.
      </div>
    </div>
    <div class="ob-col2">
      <img src="../../../assets/img/obiettivo-img.svg" alt="" aria-hidden="true" />
    </div>
  </div>
</section>

<!--mobile view-->
<section class="d-block d-md-block d-lg-none">
  <div class="obiettivo-sm">
    <div class="ob-col1">
      <div class="obiettivo-title">
        <h2 class="blue-50 bold">Obiettivo inclusività</h2>
      </div>
      <div class="neutral-90 mt-4 mt-xl-3 mb-xl-5 course-desc">
        I nostri corsi di coding ed educazione al digitale promuovono non
        soltanto lo sviluppo di competenze tecniche, informatiche e il problem
        solving, ma anche di importanti valori come l’inclusività.
      </div>
      <div class="ob-col2">
        <img src="../../../assets/img/obiettivo-img.svg" alt="" aria-hidden="true" />
      </div>

      <div class="neutral-90 mt-4 mt-xl-3 mb-xl-5 course-desc">
        Tramite il coding, bambini e ragazzi possono apprendere i valori della
        cooperazione e della collaborazione (cooperative learning): scoprono che
        un problema può essere risolto più facilmente se condividono idee e
        suggerimenti. La classe diventa una comunità di apprendimento, in cui le
        conoscenze sono costruite, condivise e scambiate.
      </div>
    </div>
  </div>
</section>

<!--desktop view-->
<section class="d-none d-lg-block">
  <div class="container grid mt-5">
    <div class="row mt-5 p-0 m-0">
      <div class="frame mt-5 mb-xxl-5 px-3">
        <h2 class="blue-50 text-center bold">
          Cosa impareranno i tuoi studenti con i corsi Easycode?
        </h2>
      </div>

      <div class="arg-container grid mt-5 mb-5">
        <div class="row">
          <div class="col-xxl-4 mt-xxl-5">
            <div class="arg-card">
              <img
                src="assets/img/Icona_blu.svg"
                class="balloon"
                width="106.72px"
                alt=""
                aria-hidden="true"
              />
              <p class="course-desc w-700">Cooperazione</p>
              <p class="course-desc">
                Attraverso le nostre attività, i bambini sperimenteranno
                l'importanza del lavoro di gruppo. Comunicazione, ascolto attivo
                e risoluzione dei conflitti, saranno tutte competenze essenziali
                per il loro futuro.
              </p>
            </div>
          </div>

          <div class="col-xxl-4 mt-5">
            <div class="arg-card">
              <img
                src="assets/img/icona gialla.svg"
                class="balloon"
                width="106.72px"
                alt=""
                aria-hidden="true"
              />
              <p class="course-desc w-700">Problem Solving</p>
              <p class="course-desc">
                Gli studenti impareranno a risolvere problemi complessi
                attraverso la sperimentazione, l'analisi e la riflessione
                critica. Tramite il coding, bambini e ragazzi faranno i primi
                passi verso il pensiero computazionale.
              </p>
            </div>
          </div>

          <div class="col-xxl-4 mt-5">
            <div class="arg-card">
              <img
                src="assets/img/icona verde.svg"
                class="balloon"
                width="106.72px"
                alt=""
                aria-hidden="true"
              />
              <p class="course-desc w-700">Prepararsi al futuro</p>
              <p class="course-desc">
                Con i nostri corsi di coding, i ragazzi imparano a comprendere e
                utilizzare la tecnologia in modo critico e creativo. In questo
                modo, saranno pronti ad affrontare le sfide del futuro con
                fiducia e successo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--mobile view-->
<section class="d-block d-md-block d-lg-none">
  <div class="row mt-5 p-0 m-0" #myElement2>
    <div class="frame mt-5 mb-xxl-5 px-3">
      <h2 class="blue-50 text-center bold">
        Cosa impareranno i tuoi studenti con Easycode?
      </h2>
    </div>

    <ng-container *ngFor="let course of cardList">
      <div>
        <div
          class="mb-4"
          *ngIf="course.id === cardSelected"
          style="margin: auto"
        >
          <div class="frame mt-5 arg-card mb-xxl-5 px-3">
            <img
              [src]="course.img"
              width="106.72px"
              [class]="course.class"
              alt="Un mondo di corsi per mettersi in gioco"
             
            />

            <div class="course-txt p-3">
              <p class="course-desc w-700">{{ course.name }}</p>
              <p class="course-desc">{{ course.text }}</p>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="row d-block d-md-block d-lg-none">
    <div class="col pointer-slide">
      <div (click)="changeSlideCard(1)" class="pointer">
        <img src="assets/img/slide-selected.svg" *ngIf="cardSelected == 1" alt="" aria-hidden="true" />
        <img src="assets/img/slide-unselected.svg" *ngIf="cardSelected != 1" alt="" aria-hidden="true" />
      </div>
      <div (click)="changeSlideCard(2)" class="pointer">
        <img src="assets/img/slide-selected.svg" *ngIf="cardSelected == 2" alt="" aria-hidden="true" />
        <img src="assets/img/slide-unselected.svg" *ngIf="cardSelected != 2" alt="" aria-hidden="true" />
      </div>
      <div (click)="changeSlideCard(3)" class="pointer">
        <img src="assets/img/slide-selected.svg" *ngIf="cardSelected == 3" alt="" aria-hidden="true" />
        <img src="assets/img/slide-unselected.svg" *ngIf="cardSelected != 3" alt="" aria-hidden="true" />
      </div>
    </div>
  </div>
</section>

<div style="display: flex; justify-content: center">
  <button class="btn-lightblue my-5" routerLink="/didattica-digitale-per-scuole">
    <span class="button-txt">Vai al Progetto</span>
  </button>
</div>

<app-iscriviti></app-iscriviti>
